import { push } from '@lagunovsky/redux-react-router'
import cx from 'classnames'
import { useEffect, useRef } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { PATH_NAME } from '../../app/constants'
import FormChangePassword from '../../components/Forms/FormChangePassword/FormChangePassword'
import FormContactInfo from '../../components/Forms/FormContactInfo/FormContactInfo'
import FormLostCard from '../../components/Forms/FormLostCard/FormLostCard'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'
import useErrorMessage from '../../components/Windows/InfoWindow/hooks/useErrorMessage'
import { formatDate } from '../../global/helpers'
import BecomeMemberHeader from './components/BecomeMemberHeader/BecomeMemberHeader'
import CinestarClub from './components/CinestarClub/CinestarClub'
import ClubMemberHeader from './components/ClubMemberHeader/ClubMemberHeader'
import DesktopMenuBar from './components/DesktopMenuBar/DesktopMenuBar'
import MobileMenuBar from './components/MobileMenuBar/MobileMenuBar'
import TicketsAndReserv from './components/TicketsAndReserv/TicketsAndReserv'
import hocUserProfile from './hocUserProfile'
import useSticky from './hooks/useSticky'

import { cinemaSlugToId } from 'global/helpers/cinemaList'
import { useLocation } from 'react-router'
import './UserProfile.scss'

const UserProfile = ({
    isAuth,
    firstname,
    lastname,
    points,
    cardValidity,
    logout,
    registerClub,
    loading,
    error,
    success,
    isCardValid,
    isCardExpiring,
    cardNumber,
    checkLogin,
    getAccountOrders,
    user,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const errorMessage = useErrorMessage(error?.message)
    const stickyRef = useRef()
    const isSticky = useSticky(stickyRef)

    const ticketsRef = useRef(null)
    const cinestarClubRef = useRef(null)
    const lostCardRef = useRef(null)
    const contactInfoRef = useRef(null)
    const changePassRef = useRef(null)

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)

    if (cinemaSlugToId(paramsObject.site)) {
        const cinemaId = cinemaSlugToId(paramsObject.site)
        localStorage.setItem('site', paramsObject.site)
        localStorage.setItem('cinemaid', cinemaId)
    }

    if (!isAuth) {
        console.warn('not auth')
        dispatch(push(PATH_NAME.LOGIN))
    }
    const run = useRef(false)
    useEffect(() => {
        if (!run.current) {
            checkLogin()
            getAccountOrders()
            run.current = true
        }
    }, [])

    const isClubMember = isCardValid && !isCardExpiring

    return (
        <Container fluid className={'user-profile-page d-flex flex-column'}>
            {isCardValid || isCardExpiring ? (
                <ClubMemberHeader
                    user={user}
                    isCardValid={isCardValid}
                    firstname={firstname}
                    lastname={lastname}
                    points={points}
                    cardValidity={formatDate(cardValidity)}
                    isExpiring={isCardExpiring}
                    cardNumber={cardNumber}
                />
            ) : (
                <BecomeMemberHeader registerClub={registerClub} loading={loading} />
            )}
            {/* This div is here only to track position of Y for sticky bars */}
            <div ref={stickyRef} className={cx(isSticky && 'mb-10')} />
            <DesktopMenuBar
                logout={logout}
                loading={loading}
                isClubMember={isClubMember}
                ticketsRef={ticketsRef}
                cinestarClubRef={cinestarClubRef}
                lostCardRef={lostCardRef}
                contactInfoRef={contactInfoRef}
                changePassRef={changePassRef}
                isSticky={isSticky}
            />
            <MobileMenuBar
                logout={logout}
                loading={loading}
                isClubMember={isClubMember}
                ticketsRef={ticketsRef}
                cinestarClubRef={cinestarClubRef}
                lostCardRef={lostCardRef}
                contactInfoRef={contactInfoRef}
                changePassRef={changePassRef}
                isSticky={isSticky}
            />
            <Container
                fluid
                className="user-profile-page--content position-relative d-flex flex-column align-items-center"
            >
                {error && <InfoWindow color={'red'} description={errorMessage} withTimer withScroll />}
                <div className="snack-bar-testing"></div>
                <TicketsAndReserv sectionRef={ticketsRef} loading={loading} />
                {isClubMember && <CinestarClub sectionRef={cinestarClubRef} loading={loading} />}
                {isClubMember && <FormLostCard sectionRef={lostCardRef} loading={loading} />}
                <FormContactInfo sectionRef={contactInfoRef} loading={loading} />
                <FormChangePassword sectionRef={changePassRef} loading={loading} />
                <img
                    src={'images/cinestar/astronaut-thumbs-up.png'}
                    alt={'astronaut-thumbs-up'}
                    className={'astronaut-animate w-50 h-auto'}
                />
            </Container>
        </Container>
    )
}

export default hocUserProfile(UserProfile)
